<template>
  <el-container direction="vertical">
    <el-input
      placeholder="输入关键字进行过滤"
      v-model="filterText">
    </el-input>

    <el-tree
      ref="tree"
      :data="data"
      check-strictly
      @check-change="treeChange"
      show-checkbox
      node-key="func_id"
      :props="defaultProps"
      :default-checked-keys="[]"
      :filter-node-method="filterNode">
    </el-tree>

    <el-row v-if="!readOnly" style="margin-top: 30px;text-align:center;">
      <el-button class="btn_dialog" @click="$emit('tableCloseDialog')">取消</el-button>
      <el-button class="btn_dialog cz" @click="onReset">重置</el-button>
      <el-button class="btn_dialog qd" @click="onOk">确定</el-button>
    </el-row>
  </el-container>
</template>

<script>
import Backend from '@/api/backend'

export default {
  name: '',
  data () {
    const readOnly = Number(this.rowData.role_id) < 6
    return {
      readOnly: readOnly,
      filterText: '',
      data: [],
      func_ids: [],
      defaultProps: {
        children: 'child_nodes',
        label: 'func_name'
      }
    }
  },

  watch: {
    filterText (val) {
      this.$refs.tree.filter(val)
    }
  },

  props: ['rowData'],

  mounted () {
    this.getFuncTree()
  },

  methods: {
    getFuncTree () {
      Backend.post(this, 'function/func_tree', { role_id: this.rowData.role_id }).then((d) => {
        this.data = d.func_tree
        this.func_ids = d.func_ids.map(id => JSON.stringify(id))
        if (this.readOnly) this.deepEach(this.data)
        this.$nextTick(() => {
          this.setCheckedKeys(this.func_ids)
        })
      })
    },
    filterNode (value, data) {
      if (!value) return true
      return data.func_name.indexOf(value) !== -1
    },
    setCheckedKeys (keys) {
      this.$refs.tree.setCheckedKeys(keys)
    },
    onReset () {
      this.setCheckedKeys(this.func_ids)
    },
    onOk () {
      const halfKeys = this.$refs.tree.getHalfCheckedKeys()
      const checkedKeys = this.$refs.tree.getCheckedKeys()
      Backend.post(this, 'role/role_func_link', {
        role_id: this.rowData.role_id,
        func_ids: [...halfKeys, ...checkedKeys].join(',')
      }).then(r => {
        this.$message.success('设置成功!')
        this.$emit('tableCloseDialog')
      })
    },
    deepEach (arr) {
      arr.forEach(item => {
        item.disabled = true
        if (item.child_nodes) {
          this.deepEach(item.child_nodes)
        }
      })
    },
    treeChange (node, checked) {
      if (checked) this.$refs.tree.setChecked(node.parent_id, true)
    }
  }
}
</script>
